export const RespCode = {
  Success: 0,
};

export const ErrorCode = {
  /** 接口返回错误 */
  Wrong: -9999,
  /** 数据丢失，引导重新登录 */
  Refresh: -10000,
  /** 过期 */
  Expired: 2000002,
  /** 已到最大值 */
  Total: 2000004,
  /** 旧版理赔过 */
  HasOldClaim: 2000005,
  // /** 查询到不止一个保单 */
  // Multiple: 2000006,
  /**  保单coverd_item为空 */
  CoverdItemEmpty: 2000007,
  /** 请求错误 */
  WrongRequest: 300006,
  /** 保单被取消 */
  Cancelled: 2000003,
  Nothing: 2000001, // 无保单
};

export const ApiPath = {
  AgentApi: '/gateway/agent-service/api/',
};

export const ApiUri = {
  Upload: 'upload-files',
};

export const RequestMethod = {
  Post: 'POST',
  Get: 'GET',
};
